var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCypress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42305 15.1792C1.14272 14.1487 1 13.0784 1 12.0005C1 7.07941 4.06193 2.57981 8.61977 0.80542L9.21737 2.36653C5.29408 3.89423 2.65902 7.76551 2.65902 12.0005C2.65902 12.9294 2.78134 13.8493 3.02217 14.7359L1.42305 15.1792Z",
    fill: "#69D3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0283 7.24664C20.2546 3.80962 16.7632 1.67418 12.919 1.67418C11.5568 1.67418 10.233 1.93886 8.98679 2.45923L8.35095 0.913534C9.79972 0.308366 11.3364 0 12.919 0C17.3851 0 21.4396 2.47979 23.5 6.47314L22.0283 7.24664Z",
    fill: "url(#paint0_linear_46_13063)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36016 9.52475C10.3221 9.52475 11.1058 10.0426 11.5085 10.9458L11.5403 11.0165L13.156 10.4627L13.1216 10.3792C12.496 8.8412 11.0548 7.88525 9.36016 7.88525C8.16873 7.88525 7.20035 8.27075 6.40015 9.0622C5.60503 9.84855 5.20239 10.8379 5.20239 12.0032C5.20239 13.1583 5.60503 14.1425 6.40015 14.9289C7.20035 15.7204 8.16873 16.1058 9.36016 16.1058C11.0548 16.1058 12.496 15.1499 13.1216 13.6132L13.156 13.5297L11.5377 12.9746L11.5072 13.0478C11.1466 13.9357 10.3438 14.4663 9.36016 14.4663C8.68989 14.4663 8.12414 14.2299 7.6756 13.7648C7.222 13.2932 6.99265 12.7009 6.99265 12.0045C6.99265 11.303 7.2169 10.7222 7.6756 10.2289C8.12286 9.7612 8.68989 9.52475 9.36016 9.52475Z",
    fill: "#1B1E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4798 8.03687L17.1774 13.9177L14.8596 8.03687H12.9636L16.214 16.0634L13.9014 21.7245L15.5591 22.0573L21.2714 8.03687H19.4798Z",
    fill: "#1B1E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.198 20.9947L13.794 21.9815C13.7137 22.1768 13.5303 22.3091 13.3238 22.3181C13.1875 22.3233 13.0499 22.3271 12.911 22.3271C8.15693 22.3246 3.95078 18.9415 2.90847 14.28L1.29022 14.6488C1.87509 17.2635 3.34298 19.6366 5.42376 21.3327C7.52877 23.0479 10.1804 23.9949 12.8932 24C12.897 24 12.9174 24 12.9174 24C13.0767 24 13.2346 23.9962 13.3927 23.9898C14.2438 23.9538 15.0045 23.4154 15.3294 22.6175L15.857 21.3275L14.198 20.9947Z",
    fill: "url(#paint1_linear_46_13063)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_13063",
    x1: 11.6788,
    y1: -0.774709,
    x2: 20.8165,
    y2: 8.90108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0939,
    stopColor: "#58D09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9883,
    stopColor: "#58D09E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_46_13063",
    x1: 0.872957,
    y1: 17.4608,
    x2: 18.1793,
    y2: 22.0244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0774,
    stopColor: "#58D09E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7617,
    stopColor: "#1B1E2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCypress);
export default __webpack_public_path__ + "static/media/cypress.e8cbea3965adcc4162b56a4730ce9505.svg";
export { ForwardRef as ReactComponent };